import Vue from 'vue'
import Global from '@/scripts/Global'
import {
    Post
} from '@/classes/Post'
import {
    CPUtils
} from '@/scripts/Utils'
import MessageBuilder from '@/Builder/Message.builder'
import FileApi from '@/scripts/api/file.api'
import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import VueSignals from '@/scripts/VueSignals'
import config from '@/scripts/config'
import axios from 'axios'

export default {
    name: 'MessageExcerpt',
    data: function() {
        return {
            arrActiveChannelUsers: SessionManager.GetActiveChannelUsers(),
            loggedInUserId: SessionManager.getLoggedInUserId(),
            activeChannelDoc: SessionManager.getActiveChannel(),
        }
    },
    props: {
        message_doc: Object,
        direct: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        applyStyling(text) {
            let SpecialChars = CPUtils.getStylingChars()
            if (SpecialChars.indexOf(text[0]) > -1) {
                text = " " + text
            }
            return CPUtils.GetMessageDecodeDisplay(text)
        },
        getSubStyle(inputFeed) {
            let html = ''
            let char = ''
            let charAt = -1
            let buffer = ''
            let specialCharFound = false

            for (let letterPos = 0; letterPos < inputFeed.length; letterPos++) {
                if (inputFeed[letterPos] in config.MESSAGE_TEXT_STYLE) {
                    specialCharFound = true
                    if (char == '') {
                        char = inputFeed[letterPos]
                        charAt = letterPos
                    } else if (inputFeed[letterPos] == char) {
                        html += "<" + config.MESSAGE_HTML_STYLE[char] + ">" + inputFeed.substring(charAt + 1, letterPos) + "<" + config.MESSAGE_HTML_STYLE[char] + ">"
                        char = ''
                        charAt = -1
                        specialCharFound = false
                    } else if (char != '' && char != inputFeed[letterPos]) {
                        let tempChar = inputFeed[letterPos]
                        let tempHtml = ''
                        for (let letterSubPos = letterPos + 1; letterSubPos < inputFeed.length; letterSubPos++) {
                            if (inputFeed[letterSubPos] == tempChar) {
                                tempHtml = "<" + config.MESSAGE_HTML_STYLE[tempChar] + ">" +
                                    inputFeed.substring(letterPos + 1, letterSubPos) +
                                    "</" + config.MESSAGE_HTML_STYLE[tempChar] + ">"
                                letterPos = letterSubPos + 1
                                break
                            }
                        }
                        html += "<" + config.MESSAGE_HTML_STYLE[char] + ">" + tempHtml + "</" + config.MESSAGE_HTML_STYLE[char] + ">"
                        char = ''
                        charAt = -1
                        specialCharFound = false
                    }
                } else {
                    if (!specialCharFound)
                        html += inputFeed[letterPos]
                }
            }
            return html
        },
        getEmoji(emojiID) {
            return CPUtils.getEmojiIMG(emojiID)
        },
        DecodeMessage(message_doc) {
            let text = message_doc.hasOwnProperty('origin_parsed') ? message_doc.origin_parsed : (message_doc.hasOwnProperty('origin') ? message_doc.origin : '');
            if (typeof text != 'undefined') {
                let textArr = text.split(/(\[[A-F0-9]{32}\])/g)
                return textArr
            }
        },
        Display(text) {
            if (text.length == 34 &&
                text[0] == "[" &&
                text[33] == "]") {
                if (text.slice(1, 33) in this.$props.message_doc.parsed_items) {
                    return this.$props.message_doc.parsed_items[text.slice(1, 33)]
                }
            }
            return {
                "text": text,
                "type": "text"
            }
        },
        getUserName(user_id) {
            return SessionManager.getUser(user_id).username
        },
        getUserData(user_id) {
            if (user_id != SessionManager.getLoggedInUserId()) {
                let user = SessionManager.getUser(user_id)
                if (typeof user == 'undefined') {
                    return
                }

                if (this.activeChannelDoc.removed_users.indexOf(user.user_id) > -1) {
                    user.removed = true
                } else {
                    user.removed = false
                }
                return user
            } else if (user_id == SessionManager.getLoggedInUserId()) {
                return SessionManager.getLoggedInUser()
            }
        },
    }
}
